import React, { useEffect, useState } from "react";

import "./more-about-authors.m.css";
import AuthorImage from "../AuthorImage";
import { Link } from "@quintype/components";
import { handleAuthorInteraction } from "../../../../ga-utils";
import { ABOUT_THE_AUTHOR_TITLE } from "../../../../constants";
import { get } from "lodash";
import { getAuthorById } from "../../../../../api/utils";

const MoreAboutAuthors = ({ authors = [], story = {}, config, pageType = "story-page" }) => {
  const [authorRoles, setAuthorRoles] = useState([]);

  if (authors.length < 0) {
    return null;
  }

  useEffect(() => {
    const fetchAuthorRoles = async () => {
      if (authors.length > 0) {
        try {
          const roles = [];
          for (const author of authors) {
            const authorInfo = await getAuthorById(author.id);
            if (get(authorInfo, ["metadata", "designation"])) {
              roles.push(get(authorInfo, ["metadata", "designation"]));
            }
          }
          setAuthorRoles(roles);
        } catch (error) {
          console.error("Error fetching author information:", error);
        }
      }
    };

    fetchAuthorRoles();
  }, [authors]);

  const newAuthors = authors.filter((author) => author.bio && author.bio.trim() !== "");

  return (
    <>
      {newAuthors.length > 0 && (
        <div styleName="wrapper">
          <div styleName="title">{ABOUT_THE_AUTHOR_TITLE}</div>
          {newAuthors.map((author, index) => {
            const authorUrl = `/author/${author.slug}`;

            return (
              <div styleName="author-info" key={author.id}>
                <div styleName="image-name-wrapper">
                  <AuthorImage author={author} isClickable={true} />
                  <div styleName="name-role-wrapper">
                    <Link
                      href={authorUrl}
                      disableAjaxLinks={true}
                      onTouchStart={() => handleAuthorInteraction(author, authorUrl, pageType, config, story)}
                      onMouseDown={() => handleAuthorInteraction(author, authorUrl, pageType, config, story)}
                    >
                      <div styleName="author-name">{author.name}</div>
                    </Link>
                    {authorRoles[index] && <div styleName="author-role">{authorRoles[index]}</div>}
                  </div>
                </div>
                {author.bio && <div styleName="author-bio">{author.bio}</div>}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default MoreAboutAuthors;
